import * as styles from './ApplicantDocumentChecklistActionCell.module.css'

function ApplicantDocumentChecklistActionCell({
  children,
  className = styles.ApplicantDocumentChecklistActionCell,
}) {
  return <div className={className}>{children}</div>
}

export default ApplicantDocumentChecklistActionCell
